import { parse } from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'

const initialLoad = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_DELIVERABILITY_SUMMARY_URL))
  .map(() => parse(history.location.search))
  .mergeMap((searchParams) => [
    Actions.defineCommunity(store.getState().app.selectedCommunity),
    Actions.fetchDomainEngagementSummary(store.getState().app.selectedCommunity,
                                         searchParams.sinceDate)])

export const epic = ReduxObservable.combineEpics(
  initialLoad,
)



// WEBPACK FOOTER //
// ./src/pages/domain-deliverability/epic.ts